"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FineTuneTrimButton = void 0;

var _atoms = require("../../atoms");

var _format = require("../../util/format");

var _molecules = require("../../molecules");

require("./TrimmerControls.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Fine Tune Trim Button
var FineTuneTrimButton = function FineTuneTrimButton(_ref) {
  var title = _ref.title,
      adjusting = _ref.adjusting,
      startAt = _ref.startAt,
      stopAt = _ref.stopAt,
      maxDuration = _ref.maxDuration,
      onChangeStart = _ref.onChangeStart,
      onChangeStop = _ref.onChangeStop,
      validTrim = _ref.validTrim;

  var onLeftArrow = function onLeftArrow(noSec) {
    if (adjusting === "start") {
      var newStartAt = parseFloat(startAt) - parseFloat(noSec);

      if (newStartAt >= 0 && newStartAt < stopAt) {
        onChangeStart(newStartAt);
      }
    } else {
      var newStopAt = parseFloat(stopAt) - parseFloat(noSec);

      if (newStopAt > startAt) {
        onChangeStop(newStopAt);
      }
    }
  };

  var onRightArrow = function onRightArrow(noSec) {
    var newStartAt = parseFloat(startAt);
    var newStopAt = parseFloat(stopAt);

    if (adjusting === "start") {
      newStartAt = parseFloat(newStartAt) + parseFloat(noSec);

      if (newStartAt <= newStopAt) {
        onChangeStart(newStartAt);
      }
    } else {
      newStopAt = parseFloat(newStopAt) + parseFloat(noSec);

      if (newStopAt <= maxDuration) {
        onChangeStop(newStopAt);
      }
    }
  };

  var relevantTime = adjusting === "start" ? startAt : stopAt;
  var addtlStyles = validTrim ? {
    backgroundColor: "var(--teal-10-color)"
  } : {
    backgroundColor: "var(--error-tint2-color)"
  };
  var labelColor = validTrim ? _atoms.Color.TraceShade2 : _atoms.Color.Error;
  var buttonsColor = validTrim ? _atoms.Color.Teal40 : _atoms.Color.Error;
  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "FineTuneTrimButton",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    bold: true,
    type: _atoms.Label.Type.SmallBody,
    color: _atoms.Color.Grey2,
    content: title,
    marginBottom: "1"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "buttons-container",
    alignItems: "center",
    justifyContent: "space-between",
    styles: addtlStyles
  }, /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    className: "button-decrease",
    trkAction: "Color Selected",
    borderColor: _atoms.Color.Transparent,
    backgroundColor: _atoms.Color.Transparent,
    icon: _atoms.Icon.Type.CheveronLeft,
    iconColor: buttonsColor,
    onClick: function onClick(e) {
      return onLeftArrow(0.2);
    }
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "time",
    content: (0, _format.formatMinutesAndSecondsForTrimmer)(relevantTime),
    color: labelColor
  }), /*#__PURE__*/_react.default.createElement(_molecules.RoundButton, {
    className: "button-increase",
    trkAction: "Color Selected",
    borderColor: _atoms.Color.Transparent,
    backgroundColor: _atoms.Color.Transparent,
    icon: _atoms.Icon.Type.CheveronRight,
    iconColor: buttonsColor,
    onClick: function onClick(e) {
      return onRightArrow(0.2);
    }
  })));
};

exports.FineTuneTrimButton = FineTuneTrimButton;